/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Theme_Default_BadgeInputs */

const en_onboarding_theme_default_badge = /** @type {(inputs: Onboarding_Theme_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`default`)
};

const es_onboarding_theme_default_badge = /** @type {(inputs: Onboarding_Theme_Default_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`predeterminado`)
};

/**
* | output |
* | --- |
* | "default" |
*
* @param {Onboarding_Theme_Default_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_theme_default_badge = /** @type {((inputs?: Onboarding_Theme_Default_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Theme_Default_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_theme_default_badge(inputs)
	return en_onboarding_theme_default_badge(inputs)
});